<template>
    <div class="payment-confirmed">
        <header class="absolute">
            <a :href="ctaRedirectTo.path" :title="ctaRedirectTo.title">
                <SaasIcon
                    icon="svgLogoSellsyText"
                    :width="118"
                    :height="28"
                    class="ml-2 mt-2 secondary-blue"
                />
            </a>
        </header>
        <section class="flex-column hp-10 jc-center ai-center">
            <SaasIcon icon="svgCheck" :width="171" :height="162" />
            <h1 class="payment-confirmed-title">
                {{ $l10n.__('Merci d’avoir renouvelé votre abonnement Sellsy !') }}
            </h1>
            <p class="payment-confirmed-subtitle" v-if="pricingVersion < 3">
                {{ $l10n.__('Un email de confirmation vient de vous être envoyé.') }}
            </p>
            <a
                class="payment-confirmed-cta"
                :href="ctaRedirectTo.path"
                :title="ctaRedirectTo.title"
            >
                <CompassButton
                    :label="ctaRedirectTo.btnLabel"
                    type="primary"
                    size="large"
                    class="wp-10 px-4 fs-4 lh-24"
                />
            </a>
            <p
                class="payment-confirmed-help"
                v-html="
                    $t.__('pages.subscription.need_help', {
                        startLinkHelp: `<a class='fs-4 link' href='https://help.sellsy.com' target='_blank'>`,
                        startLinkContact: `${
                            isConnected
                                ? `<a class='fs-4 link' onclick='MySupport.getForm()'>`
                                : `<a class='fs-4 link' href='https://go.sellsy.com'>`
                        }`,
                        endLink: `</a>`,
                    })
                "
            ></p>
        </section>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

const corp = createNamespacedHelpers('corp');

export default {
    name: 'RenewConfirmed',
    components: {
        SaasIcon,
    },
    props: {
        isConnected: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        ...corp.mapState(['pricingVersion']),
        /**
         * Return an object with path and title of call to action
         */
        ctaRedirectTo() {
            return {
                path: '/home',
                title: this.$l10n.__("Page d'accueil"),
                btnLabel: this.$l10n.__('Revenir à Sellsy'),
            };
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';

[class$='renew-payment-confirmed'] #sellsy_app {
    background-color: $secondary-grey !important;

    .payment-confirmed {
        .payment-confirmed-title {
            font-size: 32px;
            line-height: 39px;
            font-weight: $font-weight-regular;
            margin-top: spacer(8);
            margin-bottom: 0;
        }
        .payment-confirmed-subtitle {
            font-size: $very-big-font-size;
            line-height: 26px;
            font-weight: $font-weight-regular;
            margin: 0;
            color: $gray-60;
            margin-top: spacer(3);
        }
        .payment-confirmed-cta {
            margin-top: spacer(6);
            margin-bottom: spacer(4);
            > * {
                line-height: 22px;
            }
        }
        .payment-confirmed-help {
            font-size: $big-font-size;
            line-height: 24px;
            font-weight: $font-weight-semibold;
            margin: 0;
        }
    }
}
</style>
